import Model from 'flarum/common/Model';
export default class UserScore extends Model {
  userId = Model.attribute('userId');
  seasonId = Model.attribute('seasonId');
  totalPoints = Model.attribute('totalPoints');
  totalPicks = Model.attribute('totalPicks');
  correctPicks = Model.attribute('correctPicks');
  accuracy = Model.attribute('accuracy');
  user = Model.hasOne('user');
  season = Model.hasOne('season');
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/UserScore', UserScore);